import { render, staticRenderFns } from "./InstagramAuthResult.vue?vue&type=template&id=6857e4be"
import script from "./InstagramAuthResult.vue?vue&type=script&lang=js"
export * from "./InstagramAuthResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports